
import { BankAccountApi } from "@/api/BankAccountApi";
import { CurrencyApi } from "@/api/CurrencyApi";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { generateCurrencyOptionLabel } from "@utils/Currency";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";
import { generatePaymentMethodOptions } from "@utils/Utils";

const ProviderInvoiceNoteFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "hidden",
                        "name": "providerInvoiceId",
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "currencyId",
                        "label": "Moneda",
                        "optionsFunction": () => CurrencyApi.optionsList({}, (i) => generateCurrencyOptionLabel(i)),
                        "onChangePubSub": (value: string) => CurrencyIdPubSub.publish({ currencyId: value }),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "number",
                        "name": "exchange_rate",
                        "label": "Tipo de Cambio",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "number",
                        "name": "recibo",
                        "label": "Numero Recibo",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 4
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "monto",
                        "label": "Monto",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "cobrador",
                        "label": "Nombre Cobrador",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "forma_pago",
                        "label": "Forma de Pago",
                        "options": generatePaymentMethodOptions([1, 2, 4, 5, 7]),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "reference",
                        "label": "Numero Referencia",
                        "isHorizontal": true,
                        "visibleIf": {
                            "forma_pago": ["2", "5", "7"]
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "bankAccountId",
                        "label": "Cuenta Bancaria",
                        "visibleIf": {
                            "forma_pago": ["2", "5", "7"]
                        },
                        "isHorizontal": true,
                        "optionsFunction": () => BankAccountApi.optionsList(),
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                    },
                ],
            ]
        }
    ],
};


export default ProviderInvoiceNoteFormConfig;